module.exports = __webpack_public_path__ + "static/media/29ADMSPC9.dc55b6be.jpg";